import { setLearnModeRecord, setLearnStrikeCount, setLearnModeStrikeType, sendBarAverage, setErrorLearnBar, sendBarMult } from '../actions'
import { averageArray, exportBarData, isValidRecord, findNextLearnIndex, clamp } from '../utilities'
import { errorSound } from '../components/LearnModeSounds'

import {
  SELECT_LEARN_BAR,
  OPEN_LEARN_MODE,
  CLOSE_LEARN_MODE,
  STORE_BARS_TARE,
  STORE_BARS_AVERAGES,
  STORE_BAR_AVERAGE,
  STORE_BARS_MULTS,
  STORE_BAR_MULT,
  RESET_BAR_RECORD,
  CREATE_BAR_RECORD,
  SET_BAR_RECORD,
  RESET_BAR_RECORDS,
  RESET_BAR_STRIKE_ICONS,
  RESET_LEARNED_AVERAGES,
  SET_LEARN_STRIKE_COUNT,
  LEARN_MODE_BAR_STRIKE_STATUS,
  CALCULATE_BAR_AVERAGE,
  EXPORT_BAR_DATA,
  OPEN_LEARN_MODE_TOUR
} from './actionTypes'

export const selectLearnBar = (bar) => {
  return (dispatch) => {
    dispatch({ type: SELECT_LEARN_BAR, bar: bar })
    dispatch({ type: SET_LEARN_STRIKE_COUNT, count: 0})
  }
};

export const openLearnMode = (active) => {
  return ({type: OPEN_LEARN_MODE})
};

export const closeLearnMode = () => {
  return ({type: CLOSE_LEARN_MODE})
}

export const storeBarsTare = (barsTare) => {
  console.log('<<-- store bar tare to editor: success');
  return ({ type: STORE_BARS_TARE, tares: barsTare });
}

export const storeBarAverage = (mode, barIndex, average) => {
  console.log(`<<-- store bar average ${mode} to editor: success`);
  return ({ type: STORE_BAR_AVERAGE, mode: mode, barIndex: barIndex, average: average });
}

export const storeBarAverages = (mode, barAverages) => {
  console.log(`<<-- store bar averages ${mode} to editor: success`);
  return ({ type: STORE_BARS_AVERAGES, mode: mode, averages: barAverages });
}

export const storeBarMults = (mode, barMults) => {
  console.log(`<<-- store bar ${mode} mults to editor: success`);
  return ({ type: STORE_BARS_MULTS, mode: mode, mults: barMults });
}

export const storeBarMult = (mode, barIndex, barMult) => {
  console.log(`<<-- store bar ${barIndex} ${mode} mult to editor ${barMult}`);
  return ({ type: STORE_BAR_MULT, mode: mode, barIndex: barIndex, mult: barMult });
}

export const createBlankRecord = () => {
  return (dispatch, getState) => {
    const barIndex = getState().editor.selectedLearnBar,
          learnRecords = getState().learnMode.records

          // if record already exists
    if(learnRecords[barIndex]) return

    dispatch({type: CREATE_BAR_RECORD, barIndex: barIndex})
  }
}

export const resetBarRecord = () => {
  return (dispatch, getState) => {
    const barIndex = getState().editor.selectedLearnBar,
          strikeType = getState().editor.learnModeStrikeType,
          learnRecords = getState().learnMode.records

    if(!learnRecords[barIndex]) return

    dispatch({type: RESET_BAR_RECORD, barIndex: barIndex, strikeType: strikeType})
  }
}

export const resetBarRecords = () => {
  return (dispatch) => {
    dispatch({type: RESET_BAR_RECORDS})
  }
}
export const resetBarStrikeIcons = () => {
  return (dispatch) => {
    dispatch({type: RESET_BAR_STRIKE_ICONS})
  }
}
export const resetAverageRecords = (mode) => {
  return (dispatch) => {
    dispatch({type: RESET_LEARNED_AVERAGES, mode: mode})
  }
}

export const resetLearnModeRecords = () => {
  return (dispatch) => {
    dispatch(resetBarRecords())
    dispatch(resetBarStrikeIcons())
    dispatch(resetAverageRecords('low'))
    dispatch(resetAverageRecords('high'))
  }
}

export const calculateLearnedAvgLows = (send = true) => {
  return (dispatch, getState) => {
    const records = getState().learnMode.records,
          barTares = getState().learnMode.tares

    records.filter(Boolean).forEach((record, index) => {
      const averageLow = clamp(averageArray(record.soft) - barTares[index], 0, 255)

      dispatch({
        type: CALCULATE_BAR_AVERAGE,
        mode: 'low',
        barIndex: index,
        average: averageLow
      })
      // send average lows to the device
      if(send) dispatch(sendBarAverage('low', index, averageLow))
    })
  }
}

export const calculateLearnedAvgHighs = (send = true) => {
  return (dispatch, getState) => {
    const records = getState().learnMode.records

    records.filter(Boolean).forEach((record, index) => {
      const averageHigh = averageArray(record.hard);

      dispatch({
        type: CALCULATE_BAR_AVERAGE,
        mode: "high",
        barIndex: index,
        average: averageHigh,
      });
      if (send) dispatch(sendBarAverage("high", index, averageHigh));
    });
  }
}

export const setBarStrikeComplete = (barIndex, strikeType) => {
  // TODO: prevent double same type records multiple set
  // soft = 1, hard = 2
  const strikeTypeNum = strikeType === 'soft' ? 1 : 2

  return {
    type: LEARN_MODE_BAR_STRIKE_STATUS,
    barIndex: barIndex,
    strikeTypeNum: strikeTypeNum
  }
}

export const setBarRecord = (data) => {
  const [barIndex, rawVelocity] = data

  return (dispatch, getState) => {
    try {
      const strikeType = getState().editor.learnModeStrikeType;
      const strikeTypeLength = getState().learnMode.records[barIndex][strikeType].length;
      // console.log(">> strikeTypeLength", strikeTypeLength);
      if (strikeTypeLength >= 5) return
      // add bar record
      dispatch({
        type: SET_BAR_RECORD,
        barIndex: barIndex,
        strikeType: strikeType,
        rawVelocity: rawVelocity,
      });
  
      // set strike counter & play sound
      dispatch(setLearnStrikeCount())
      
    } catch (error) {
      console.log("error", error);
      dispatch({
        type: 'ERROR',
        message: error.toString()
      });
    }
  }
}

export const checkBarRecords = (currentStrokeRecord) => {

 return (dispatch, getState) => {
   const learnModeAuto = getState().editor.learnModeAuto,
     selectedLearnBar = getState().editor.selectedLearnBar,
     strikeType = getState().editor.learnModeStrikeType,
     completedStrikes = getState().learnMode.completedStrikes,
     learnRecords = getState().learnMode.records,
     validRecord = isValidRecord(currentStrokeRecord, strikeType, 50),
     barStrikeStatus = completedStrikes[selectedLearnBar],
     completedHard = learnRecords[selectedLearnBar].hard.length === 5,
     completedSoft = learnRecords[selectedLearnBar].soft.length === 5;
    // 3 means complete (1+2)

  // is valid (5 strikes for one type) and within threshold range
  if (validRecord) {
    if(window.learnLog) console.log(`>> ( √ ) Bar Regulation (${learnModeAuto ? 'auto' : 'single'}): valid bar ${selectedLearnBar} ${strikeType} record ${currentStrokeRecord}`);
    // VALID : NOT COMPLETE RECORD
    if (barStrikeStatus < 3) {
      // set striketype completed state for display; 0 = blank, 1 = soft, 2 = hard, 3 = complete
      dispatch(setBarStrikeComplete(selectedLearnBar, strikeType, true));

      let strike_type = "soft";

      // incomplete bar
      if (!completedSoft || !completedHard) {
        if (completedSoft && !completedHard) {
          // console.log(">> Bar Regulation (bar) - hard: incomplete");
          strike_type = "hard";
        } else if (completedHard && !completedSoft) {
          strike_type = "soft";
          // console.log(">> Bar Regulation (bar) - soft: incomplete");
        }

        // AUTO
        if (learnModeAuto) {
          let nextBarIndex = selectedLearnBar + 1;
          let nextStrikeType = false;

          // increment index
          // check that record index
          //// if not empty; select next strike type and index
          if (learnRecords[nextBarIndex] !== undefined) {
            // search through indexs and find the next empty record
            [nextBarIndex, nextStrikeType] = findNextLearnIndex(
              selectedLearnBar,
              completedStrikes
            );
            console.log(`244: next check: nextBarIndex ${nextBarIndex}, nextStrikeType ${nextStrikeType}`);
          } else {
            // blank record
          }

          //// incomplete: select next strike type and index
          [nextBarIndex, nextStrikeType] = findNextLearnIndex(
            selectedLearnBar,
            completedStrikes
          );

          // NOTE: gets called when no strike types are complete (first passthrough in automode)

          // set next strike type
          if (nextStrikeType) {
            console.log(`>> 259: setting next strike type ${nextStrikeType}`);
            dispatch(setLearnModeStrikeType(nextStrikeType));
            // set for later
            strike_type = nextStrikeType;
          }
          // increment bar index
          setTimeout(() => dispatch(selectLearnBar(nextBarIndex)), 100);
          // create new record
          setTimeout(() => dispatch(createBlankRecord()), 120);
        }
      } else {
        // TODO: merge this into single bar mode
        // completedSoft || completedHard
        if(learnModeAuto) {
          // bar record complete
          // calculate and send averages from strike data
          dispatch(calculateAndSendBarAverages());
          // set bar mults to unity and send
          dispatch(storeAndSendBarMults());

          // select next bar
          let [nextBarIndex, nextStrikeType] = findNextLearnIndex(
            selectedLearnBar,
            completedStrikes
          );

          if (nextBarIndex !== -1) {
            // gets called in automode when starting from non-0
            dispatch(selectLearnBar(nextBarIndex));
          }
        }
      }
      
      // completed bar : single bar
      if (!learnModeAuto && completedSoft && completedHard) {
        // VALID : COMPLETE RECORD
        console.log(`>> RECORD COMPLETE FOR BAR ${selectedLearnBar}`);

        // single mode, stop after bar complete
        // stop recording
        dispatch(setLearnModeRecord(false));

        // reset type
        strike_type = "soft";
        dispatch(setLearnModeStrikeType("soft"));

        // both complete:
        // FINISHING PROCEDURE

        // reset counter
        dispatch(setLearnStrikeCount(true));
        // calculate and send averages from strike data
        dispatch(calculateAndSendBarAverages());
        // set bar mults to unity and send
        dispatch(storeAndSendBarMults());
      }

      if(!learnModeAuto){
        // switch to unfinished strike type in single mode
        dispatch(setLearnModeStrikeType(strike_type));
      }

      // reset count
      dispatch(setLearnStrikeCount(true));
    }
  } else {
    // this happens on start record
    // not a complete or valid record
      if (learnRecords[selectedLearnBar][strikeType].length === 5) {
        // if invalid record, reset things and try again
        dispatch(resetBarRecordWhileRecording(selectedLearnBar));

      } else {
        // incomplete record
        if (window.learnLog) {
          console.log(`>> ( x ) Bar Regulation: incomplete record bar ${selectedLearnBar} status ${barStrikeStatus}: ${strikeType} record ${currentStrokeRecord}`);
        }
      }
    }
  };
};

export const calculateAndSendBarAverages = () => {
  // TODO: remove timeouts if not needed by the device
  return (dispatch, getState) => {
    // TODO: rename selectedLearnBar --> currentLearnBar
    const selectedLearnBar = getState().editor.selectedLearnBar,
      learnRecords = getState().learnMode.records,
      barTares = getState().learnMode.tares,
      barTare = barTares[selectedLearnBar],
      softRecord = learnRecords[selectedLearnBar].soft,
      hardRecord = learnRecords[selectedLearnBar].hard;

    // calculate average low
    setTimeout(() => {
      const calculatedAverageLow = clamp(
        averageArray(softRecord) - barTare,
        0,
        255
      );

      dispatch({
        type: CALCULATE_BAR_AVERAGE,
        mode: "low",
        barIndex: selectedLearnBar,
        average: calculatedAverageLow,
      });

      dispatch(sendBarAverage("low", selectedLearnBar, calculatedAverageLow));
    }, 200);

    // calculate average high
    setTimeout(() => {
      const calculatedAverageHigh = averageArray(hardRecord);

      dispatch({
        type: CALCULATE_BAR_AVERAGE,
        mode: "high",
        barIndex: selectedLearnBar,
        average: calculatedAverageHigh,
      });

      dispatch(sendBarAverage("high", selectedLearnBar, calculatedAverageHigh));
    }, 300);
  }
}

export const storeAndSendBarMults = (value = '1.00') => {
  return (dispatch, getState) => {
    const selectedLearnBar = getState().editor.selectedLearnBar
    setTimeout(() => {
      // set barLowMult
      dispatch(sendBarMult("low", selectedLearnBar, value));
      dispatch(storeBarMult("low", selectedLearnBar, value));
    }, 400);

    setTimeout(() => {
      // set barLowMult
      dispatch(sendBarMult("high", selectedLearnBar, value));
      dispatch(storeBarMult("high", selectedLearnBar, value));
    }, 500);
  }
}

export const storeAndSendAllBarsMults = (value = '1.00') => {
  return (dispatch, getState) => {
    const selectedLearnBar = getState().editor.selectedLearnBar
    setTimeout(() => {
      // set barLowMult
      dispatch(sendBarMult("low", selectedLearnBar, value));
      dispatch(storeBarMult("low", selectedLearnBar, value));
    }, 400);

    setTimeout(() => {
      // set barLowMult
      dispatch(sendBarMult("high", selectedLearnBar, value));
      dispatch(storeBarMult("high", selectedLearnBar, value));
    }, 500);
  }
}

export const resetBarRecordWhileRecording = (selectedLearnBar, strikeType) => {
  return (dispatch) => {
    console.log(">> Bar Regulation : invalid record: reseting");
    // reset bar record for strike type
    dispatch(resetBarRecord(strikeType));
    // toggle record
    setTimeout(() => dispatch(setLearnModeRecord(true)), 40);
    setTimeout(() => dispatch(setLearnStrikeCount(true)), 60);
    // set error bar & play sound
    setTimeout(() => dispatch(setErrorLearnBar(selectedLearnBar)), 60);
    setTimeout(() => dispatch(setErrorLearnBar(-1)), 2060);
    // error sound
    errorSound(155.56); // Hz
    errorSound(220); // Hz
  };
};

export const exportBarDataToJSON = () => {
  return (dispatch, getState) => {
    const learnModeData = getState().learnMode,
          editorVersion = getState().editor.editorVersion,
          firmwareVersion = getState().device.firmwareVersion

    const allData = Object.assign(
      {records: [...learnModeData.records]},
      {learnedAverageLows: [...learnModeData.learnedAverageLows]},
      {learnedAverageHighs: [...learnModeData.learnedAverageHighs]},
      {tares: [...learnModeData.tares]},
      {averageLows: [...learnModeData.averageLows].map(s => parseFloat(s))},
      {averageHighs: [...learnModeData.averageHighs].map(s => parseFloat(s))},
      {lowMults: [...learnModeData.lowMults]},
      {highMults: [...learnModeData.highMults]},
      {'editorVersion': editorVersion},
      {'firmwareVersion': firmwareVersion}
    )

    exportBarData(allData)
    dispatch({ type: EXPORT_BAR_DATA })
  }
}

export const openLearnModeTour = (state) => {
  return {
    type: OPEN_LEARN_MODE_TOUR,
    open: state
  }
}
